<template>
  <div>
    <!-- Modal Login -->
    <div
      class="modal fade"
      id="modal-login"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        style="
          margin: unset;
          padding: unset;
          width: 100%;
          max-width: 100%;
          height: 100%;
        "
        role="document"
      >
        <div
          class="modal-content"
          style="
            margin: unset;
            padding: unset;
            height: 100%;
            border-radius: unset;
          "
        >
          <div class="modal-body" style="overflow: scroll">
            <div class="row">
              <div class="col-12">
                <div class="js-validate needs-validation" autocomplete="off">
                  <div class="text-center">
                    <div class="mb-5">
                      <h1 class="display-5 mt-4">
                        {{ $t("login_page") }}
                      </h1>
                      <p class="text-dark">ورود یا ثبت‌نام</p>
                    </div>
                    <!-- <span class="divider-center text-muted mb-4">{{
                      $t("user_area")
                    }}</span> -->
                    <div class="d-grid mb-4" v-if="LoadingGoogle">
                      <div class="alert alert-dark" role="alert">
                        <div
                          class="spinner-border spinner-border-sm ms-3"
                          role="status"
                        ></div>
                        {{ $t("please_wait") }}
                      </div>
                    </div>
                  </div>

                  <!-- OTP SEND -->
                  <div v-if="showOtpSend">
                    <div class="mb-4 text-end">
                      <label class="form-label" for="signinSrEmail">
                        {{ $t("mobile") }}
                      </label>
                      <input
                        type="text"
                        class="form-control form-control-lg text-start"
                        style="direction: ltr"
                        v-model="dataItem.mobile"
                        autocomplete="off"
                        @keyup.enter="submitFormOtpSend()"
                      />
                    </div>
                    <div class="d-grid">
                      <ButtonLoading
                        :showLoading="showLoading"
                        text="ارسال"
                        @click="submitFormOtpSend()"
                      />
                    </div>
                  </div>
                  <!--END OTP SEND -->

                  <!-- OTP VERIFY -->
                  <div v-if="!showOtpSend">
                    <div class="mb-4 text-end">
                      <label class="form-label" for="signinSrEmail">
                        {{ $t("کد ارسالی") }}
                      </label>
                      <input
                        type="text"
                        class="form-control form-control-lg text-start"
                        style="direction: ltr"
                        v-model="dataItem.code"
                        autocomplete="off"
                        @keyup.enter="submitFormOtpVerify()"
                      />
                    </div>
                    <div class="d-grid">
                      <ButtonLoading
                        :showLoading="showLoading"
                        text="تایید"
                        @click="submitFormOtpVerify()"
                      />
                    </div>
                  </div>
                  <!--END OTP VERIFY -->
                </div>
              </div>
              <div
                class="col-md-12"
                style="
                  position: fixed;
                  bottom: 7px;
                  left: 0;
                  right: 0;
                  z-index: 98;
                "
              >
                <button
                  type="button"
                  class="btn btn-light mt-2 mb-md-0"
                  style="width: 100%"
                  onclick="$('#modal-login').modal('hide');"
                >
                  <i
                    class="fas fa-times"
                    style="color: var(--gray); font-size: 9px"
                  ></i>
                  بستن
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar" style="border-top: 1px solid #e8e8e8">
      <router-link to="/" class="footer-bar-a">
        <i
          class="footer-bar-i bi bi-house"
          :class="{ activeIcon: $route.path === '/' }"
        ></i>
        <span class="footer-bar-span" :class="{ active: $route.path === '/' }"
          >خانه</span
        >
      </router-link>
      <a
        class="footer-bar-a"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
        v-if="$route.name == 'PublicAgahi'"
        @click="sideBar = !sideBar"
      >
        <!-- @click="$root.openSidebarAgahi()" -->
        <i
          class="footer-bar-i bi bi-funnel"
          :class="sideBar == true ? 'activeIcon' : ''"
        ></i>
        <span class="footer-bar-span" :class="sideBar == true ? 'active' : ''"
          >فیلتر آگهی‌ها</span
        >
      </a>
      <a
        class="footer-bar-a"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapseEmployer"
        v-if="$route.name == 'PublicJobs-Search-Positions'"
        @click="sideBar = !sideBar"
      >
        <!-- @click="$root.openSidebarAgahi()" -->
        <i
          class="footer-bar-i bi bi-funnel"
          :class="sideBar == true ? 'activeIcon' : ''"
        ></i>
        <span class="footer-bar-span" :class="sideBar == true ? 'active' : ''"
          >فیلتر آگهی‌ها</span
        >
      </a>
      <a
        class="footer-bar-a"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapsePositions"
        v-if="$route.name == 'PublicJobs-Search-Cv'"
        @click="sideBar = !sideBar"
      >
        <!-- @click="$root.openSidebarAgahi()" -->
        <i
          class="footer-bar-i bi bi-funnel"
          :class="sideBar == true ? 'activeIcon' : ''"
        ></i>
        <span class="footer-bar-span" :class="sideBar == true ? 'active' : ''"
          >فیلتر رزومه کارجو</span
        >
      </a>
      <router-link to="/agahi" class="footer-bar-a">
        <i
          class="footer-bar-i bi bi-file-earmark-text"
          :class="{ activeIcon: $route.path === '/agahi' }"
        ></i>
        <span
          class="footer-bar-span"
          :class="{ active: $route.path === '/agahi' }"
          >آگهی</span
        >
      </router-link>
      <div class="footer-bar-a" @click="checkLogin()">
        <i
          class="footer-bar-i bi bi-box-arrow-in-right"
          :class="{ activeIcon: $route.name === 'PanelUser-Home' }"
        ></i>
        <span
          class="footer-bar-span"
          :class="{ active: $route.name === 'PanelUser-Home' }"
        >
          {{
            (() => {
              const isAuth = this.$store.state.userIsAuthenticated;
              if (isAuth) {
                return this.$t("پنل کاربری");
              } else {
                return this.$t("ورود");
              }
            })()
          }}
        </span>
      </div>
      <router-link :to="{ name: 'PublicApi' }" class="footer-bar-a">
        <i
          class="footer-bar-i bi bi-cloud-arrow-down"
          :class="{ activeIcon: $route.name === 'PublicApi' }"
        ></i>
        <span
          class="footer-bar-span"
          :class="{ active: $route.name === 'PublicApi' }"
          >APIs</span
        >
      </router-link>

      <router-link :to="{ name: 'PublicMapRouter' }" class="footer-bar-a">
        <i
          class="footer-bar-i bi bi-sign-turn-left"
          :class="{ activeIcon: $route.name === 'PublicMapRouter' }"
        ></i>

        <span
          class="footer-bar-span"
          :class="{ active: $route.name === 'PublicMapRouter' }"
        >
          {{ $t("مسیریاب") }}</span
        >
      </router-link>
      <label @click="openModalLayerOptions()" class="footer-bar-a">
        <i
          class="footer-bar-i bi bi-layers"
          :class="{ activeIcon: $route.name === 'layers' }"
        ></i>
        <span
          class="footer-bar-span"
          :class="{ active: activeItem === 'layers' }"
          >لایه‌ها</span
        >
      </label>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import ButtonLoading from "@/components/custom/ButtonLoading.vue";
import { toastSuccess, toastError } from "@/utils/toast";
import { checkAuth, checkAuthOperator, checkAuthUser } from "@/utils/checkAuth";

import useVuelidate from "@vuelidate/core";
import { required, minLength } from "@vuelidate/validators";
export default {
  data() {
    return {
      activeItem: null,
      sideBar: false,

      LoadingGoogle: false,
      showLoading: false,
      showPreLoad: true,
      showOtpSend: true,
      showOtpVerify: false,
      show: false,
      dataItem: {
        mobile: "",
        code: "",
      },
      googleBtn: {},
    };
  },

  methods: {
    sleep: function (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },

    checkLogin() {
      const isAuth = this.$store.state.userIsAuthenticated;

      if (!isAuth) {
        this.modalOpen();
      } else {
        this.$router.push({ name: "PanelUser-Home" });
      }
    },
    openModalLayerOptions() {
      $("#modal-layer-options").modal("show");
    },
    modalOpen() {
      const id = `#modal-login`;
      $(id).modal("show");
    },
    modalClose() {
      const id = `#modal-login`;
      $(id).modal("hide");
      //this.show = false;
    },

    submitFormOtpSend() {
      // this.v$.$validate();

      //  if (!this.v$.$error && !this.showLoading) {
      if (!this.showLoading) {
        this.showLoading = true;

        // const isFormCorrect = await this.v$.$validate();
        const isFormCorrect = true;

        const data = JSON.stringify(this.dataItem);
        const url = "/v2/users/auth/otp/send";
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        this.showLoading = true;

        axios
          .post(url, data, config)
          .then((response) => {
            this.showOtpSend = false;
            this.showOtpVerify = true;
            this.showLoading = false;
          })
          .catch((error) => {
            this.showLoading = false;
            toastError("مشکلی پیش آمده ورودی هارو چک کنید");
          });
      }
    },

    submitFormOtpVerify() {
      // this.v$.$validate();

      //  if (!this.v$.$error && !this.showLoading) {
      if (!this.showLoading) {
        this.showLoading = true;

        const data = JSON.stringify(this.dataItem);
        const url = "/v2/users/auth/otp/verify";
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        axios
          .post(url, data, config)
          .then((response) => {
            this.showLoading = false;
            const serverResponse = response.data;
            const token = serverResponse.data.accessToken;
            this.$store.commit("setUserToken", token);
            this.modalClose();
          })
          .catch((error) => {
            this.showLoading = false;
            toastError("مشکلی پیش آمده ورودی هارو چک کنید");
            this.modalClose();
          });
      }
    },
  },
  watch: {
    $route() {
      this.activeItem = null;
    },
  },
};
</script>

<style scoped>
.footer-bar-span {
  color: #2c2c2c;
  transition: color 0.3s;
}
.footer-bar-a i.activeIcon {
  color: #a62626;
}
.footer-bar-span.active {
  color: #a62626;
}
</style>